<template>
  <div class="text-center">
    <v-row>
      <v-col md="6" offset="3">
        <v-alert color="blue-grey" dark >
          Desde aquí usted podrá consultar el estado de afiliación de los
          afiliados de la obra social, y el estado de las autorizaciones e
          intenciones de los mismos, derivados a su entidad.
        </v-alert>
      </v-col>
    </v-row>

    <Login></Login>
  </div>
</template>

<script>
import Login from '@/components/Efectores/Login'
export default {
  components: {
    Login,
  },
}
</script>

<style></style>
